<template>
  <el-dialog
    :visible.sync="visibleProxy"
    :show-close="false"
    width="92%"
    top="3vh"
    :close-on-click-modal="false"
    custom-class="workflow-approval-dialog"
    append-to-body
    @open="handleOpen"
  >
    <div class="dialog-inner">
      <div class="dialog-header">
        <div class="dialog-title-wrap">
          <div class="dialog-title">{{ flowTitle }}</div>
          <div class="dialog-subtitle">{{ flowSubtitle }}</div>
        </div>
        <span class="dialog-close" @click="visibleProxy = false"><i class="el-icon-close"></i></span>
      </div>

      <div v-loading="loading" class="dialog-body">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="表单信息" name="form">
            <!-- 请假申请：对齐后台 leave-apply-page 只读单据 -->
            <div v-if="isLeaveApply && hasFormData" class="leave-bill">
              <div class="card-head">
                <span>申请信息</span>
                <span class="bill-no">单据：{{ formData.billNo || '无' }}</span>
              </div>
              <div class="mini-info-grid">
                <div class="mini-info-item">
                  <span class="mini-label">申请人员</span>
                  <span class="mini-value">{{ emptyText(formData.applyUser) }}</span>
                </div>
                <div class="mini-info-item">
                  <span class="mini-label">申请日期</span>
                  <span class="mini-value">{{ formatDateOnly(formData.applyDate) }}</span>
                </div>
                <div class="mini-info-item">
                  <span class="mini-label">申请部门</span>
                  <span class="mini-value">{{ emptyText(formData.applyDept) }}</span>
                </div>
                <div class="mini-info-item">
                  <span class="mini-label">申请职位</span>
                  <span class="mini-value">{{ emptyText(formData.applyPost) }}</span>
                </div>
              </div>

              <div v-if="!isRestLeave" class="bill-kv-grid">
                <div class="bill-kv">
                  <span class="bill-k">{{ leaveTypeLabel }}</span>
                  <span class="bill-v">{{ emptyText(formData.leaveType) }}</span>
                </div>
                <div v-if="formData.leaveType === '丧假'" class="bill-kv">
                  <span class="bill-k">丧假关系</span>
                  <span class="bill-v">{{ funeralRelationText(formData.funeralRelationType) }}</span>
                </div>
              </div>

              <div class="bill-kv-grid">
                <div class="bill-kv bill-kv--wide">
                  <span class="bill-k">请假事由</span>
                  <span class="bill-v">{{ emptyText(formData.leaveReason) }}</span>
                </div>
              </div>

              <div class="bill-kv-grid">
                <div class="bill-kv">
                  <span class="bill-k">开始日期</span>
                  <span class="bill-v">{{ formatDateOnly(formData.leaveStartTime) }}</span>
                </div>
                <div class="bill-kv">
                  <span class="bill-k">{{ isRestLeave ? '请假时长' : '请假天数' }}</span>
                  <span class="bill-v bill-v--em">{{ leaveDurationText }}</span>
                </div>
                <div class="bill-kv">
                  <span class="bill-k">结束时间</span>
                  <span class="bill-v">{{ formatDateTime(formData.leaveEndTime) }}</span>
                </div>
                <div class="bill-kv">
                  <span class="bill-k">请假小时</span>
                  <span class="bill-v">{{ emptyText(formData.leaveHour) }}</span>
                </div>
              </div>

              <div class="bill-attach">
                <span class="bill-k">相关附件</span>
                <div v-if="fileList.length" class="bill-files">
                  <span
                    v-for="(item, index) in fileList"
                    :key="item.fileId || item.name || index"
                    class="bill-file"
                  >{{ item.name || ('附件' + (index + 1)) }}</span>
                </div>
                <span v-else class="bill-v">无</span>
              </div>
            </div>

            <!-- 通用表单：单据网格 -->
            <div v-else-if="formFields.length" class="generic-bill">
              <div class="bill-kv-grid">
                <div
                  v-for="field in formFields"
                  :key="field.key"
                  class="bill-kv"
                  :class="{ 'bill-kv--wide': field.wide }"
                >
                  <span class="bill-k">{{ field.label }}</span>
                  <span class="bill-v">{{ field.value }}</span>
                </div>
              </div>
              <div v-if="fileList.length" class="bill-attach">
                <span class="bill-k">相关附件</span>
                <div class="bill-files">
                  <span
                    v-for="(item, index) in fileList"
                    :key="item.fileId || item.name || index"
                    class="bill-file"
                  >{{ item.name || ('附件' + (index + 1)) }}</span>
                </div>
              </div>
            </div>
            <div v-else class="empty-tip">暂无表单详情</div>
          </el-tab-pane>

          <el-tab-pane label="流转记录" name="records">
            <workflow-record-list :list="records" :end-time="endTime" />
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="dialog-footer">
        <el-button size="small" @click="visibleProxy = false">关闭</el-button>
        <el-button type="danger" size="small" :loading="rejecting" @click="openOpinionDialog('reject')">拒绝</el-button>
        <el-button type="primary" size="small" :loading="auditing" @click="openOpinionDialog('audit')">通过</el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="opinionVisible"
      :title="opinionType === 'audit' ? '审批通过' : '审批拒绝'"
      width="480px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-input
        v-model="opinion"
        type="textarea"
        :rows="4"
        placeholder="请输入审批意见（选填）"
      />
      <div slot="footer">
        <el-button size="small" @click="opinionVisible = false">取消</el-button>
        <el-button
          :type="opinionType === 'audit' ? 'primary' : 'danger'"
          size="small"
          :loading="auditing || rejecting"
          @click="submitApproval"
        >确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getFlowBeforeInfo, auditFlow, rejectFlow } from '@/api/flowBefore'
import { getWorkFlowFormInfo } from '@/api/workFlowForm'
import WorkflowRecordList from '@/components/workflow-record-list.vue'

const FIELD_LABELS = {
  flowTitle: '流程标题',
  billNo: '单据号',
  flowUrgent: '紧急程度',
  applyUser: '申请人员',
  applyDate: '申请日期',
  applyDept: '申请部门',
  applyPost: '申请职位',
  leaveType: '休假类别',
  leaveReason: '休假原因',
  leaveStartTime: '开始时间',
  leaveEndTime: '结束时间',
  leaveDayCount: '请假天数',
  leaveHour: '请假小时',
  funeralRelationType: '丧假关系',
  remark: '备注',
  bz: '备注',
  reason: '事由',
  amount: '金额',
  storeName: '门店',
  gsmdName: '归属门店',
  khmc: '客户名称',
  sjh: '手机号'
}

const SKIP_KEYS = [
  'id', 'flowId', 'status', 'formOperates', 'fileList', 'fileJson',
  'tenantId', 'createUser', 'createTime', 'updateUser', 'updateTime',
  'creatorUserId', 'creatorTime', 'lastModifyUserId', 'lastModifyTime',
  'deleteMark', 'deleteTime', 'deleteUserId', 'applyDeptId'
]

const WIDE_KEYS = ['leaveReason', 'reason', 'remark', 'bz', 'flowTitle']

export default {
  name: 'WorkflowApprovalDialog',
  components: { WorkflowRecordList },
  props: {
    visible: { type: Boolean, default: false },
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      activeTab: 'form',
      flowTitle: '流程审批',
      flowSubtitle: '',
      formData: {},
      formFields: [],
      fileList: [],
      fieldLabelMap: {},
      records: [],
      endTime: 0,
      /** 流程引擎编码（审批提交用，如 xjsq） */
      enCode: '',
      /** 系统表单 API Key（拉详情用，请假固定 leaveApply） */
      formApiKey: '',
      formUrl: '',
      opinionVisible: false,
      opinionType: 'audit',
      opinion: '',
      auditing: false,
      rejecting: false
    }
  },
  computed: {
    visibleProxy: {
      get() { return this.visible },
      set(v) { this.$emit('update:visible', v) }
    },
    operatorId() {
      return this.payload.operatorId || ''
    },
    processId() {
      return this.payload.processId || ''
    },
    taskNodeId() {
      return this.payload.taskNodeId || ''
    },
    hasFormData() {
      return !!(this.formData && Object.keys(this.formData).length)
    },
    isLeaveApply() {
      const key = String(this.formApiKey || '').toLowerCase()
      const url = String(this.formUrl || '').toLowerCase()
      return key === 'leaveapply' ||
        url.includes('leave-apply') ||
        url.includes('leaveapply') ||
        !!(this.formData && (this.formData.leaveType || this.formData.leaveStartTime))
    },
    isRestLeave() {
      const t = String((this.formData && this.formData.leaveType) || '')
      const url = String(this.formUrl || '').toLowerCase()
      return t === '休假' || url.includes('rest-leave')
    },
    isPersonalLeave() {
      const t = String((this.formData && this.formData.leaveType) || '')
      const url = String(this.formUrl || '').toLowerCase()
      return t === '事假' || t === '病假' || url.includes('personal-leave')
    },
    leaveTypeLabel() {
      if (this.isPersonalLeave) return '请假类别'
      if (this.isRestLeave) return '假期类型'
      return '带薪休假类别'
    },
    leaveDurationText() {
      const days = this.formData && this.formData.leaveDayCount
      if (!days && days !== 0) return '无'
      const s = String(days).trim()
      if (!s) return '无'
      if (this.isRestLeave) {
        return /天/.test(s) ? s : `${s}天`
      }
      return /天$/.test(s) ? s : `${s}天`
    }
  },
  methods: {
    emptyText(val) {
      if (val === undefined || val === null || String(val).trim() === '') return '无'
      return val
    },
    formatDateTime(val) {
      if (!val) return '无'
      const d = new Date(val)
      if (isNaN(d.getTime())) return String(val)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    formatDateOnly(val) {
      if (!val) return '无'
      const d = new Date(val)
      if (isNaN(d.getTime())) return String(val)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },
    urgentText(val) {
      const map = { 1: '普通', 2: '重要', 3: '紧急' }
      return map[Number(val)] || this.emptyText(val)
    },
    funeralRelationText(val) {
      if (Number(val) === 2) return '非直系亲属'
      if (Number(val) === 1) return '直系亲属'
      return this.emptyText(val)
    },
    safeParse(raw) {
      if (raw == null || raw === '') return null
      if (typeof raw === 'object') return raw
      try {
        return JSON.parse(raw)
      } catch (e) {
        return null
      }
    },
    isFormMetaList(val) {
      if (!Array.isArray(val) || !val.length) return false
      const first = val[0]
      if (!first || typeof first !== 'object') return false
      return !!(first.fileId || first.filedName || first.fieldId || first.fieldName || first.id || first.name)
    },
    buildLabelMapFromMeta(metaList, formOperates) {
      const map = {}
      ;(metaList || []).forEach(item => {
        if (!item || typeof item !== 'object') return
        const key = item.fileId || item.fieldId || item.id
        const label = item.filedName || item.fieldName || item.name
        if (key && label) map[key] = label
      })
      ;(formOperates || []).forEach(item => {
        if (!item || typeof item !== 'object') return
        const key = item.id || item.fileId || item.fieldId
        const label = item.name || item.filedName || item.fieldName
        if (key && label) map[key] = label
      })
      return map
    },
    /**
     * 后台请假页固定 Info('leaveApply', id)，与流程引擎 EnCode（xjsq/qjsq/ces）不同。
     * 这里按 formUrl 映射到真正的 Form API。
     */
    resolveFormApiKey(task) {
      const url = String((task && task.formUrl) || this.formUrl || '').toLowerCase()
      if (url.includes('leave-cancel')) return 'leaveCancelApply'
      if (url.includes('leave-apply') || url.includes('leaveapply')) return 'leaveApply'
      if (url.includes('attendance-punch') || url.includes('punch-apply')) return 'attendancePunchApply'
      const code = this.payload.enCode || (task && task.enCode) || this.payload.flowCode || (task && task.flowCode) || ''
      return code || ''
    },
    async loadBusinessFormData(task) {
      if (!this.processId) return {}
      const candidates = []
      const mapped = this.resolveFormApiKey(task)
      const url = String((task && task.formUrl) || '').toLowerCase()
      // 与后台 leave-apply-page 一致：请假类固定走 leaveApply
      if (url.includes('leave-apply') || url.includes('leaveapply') || /^(xjsq|qjsq|ces)/i.test(mapped || '')) {
        candidates.push('leaveApply')
      }
      if (mapped && !candidates.some(c => String(c).toLowerCase() === String(mapped).toLowerCase())) {
        candidates.push(mapped)
      }
      for (let i = 0; i < candidates.length; i++) {
        try {
          const res = await getWorkFlowFormInfo(candidates[i], this.processId)
          const data = (res && res.data) || null
          if (data && typeof data === 'object' && Object.keys(data).length) {
            this.formApiKey = candidates[i]
            return data
          }
        } catch (e) {
          // try next candidate
        }
      }
      const content = this.safeParse(task.flowFormContentJson)
      if (content && typeof content === 'object' && !Array.isArray(content) && Object.keys(content).length) {
        return content
      }
      return {}
    },
    formatFieldValue(key, val) {
      if (val === undefined || val === null || val === '') return '无'
      if (key === 'flowUrgent') return this.urgentText(val)
      if (key === 'funeralRelationType') return this.funeralRelationText(val)
      if (key === 'applyDate') return this.formatDateOnly(val)
      if (key === 'leaveStartTime' || key === 'leaveEndTime' || /Time$/i.test(key) || /Date$/i.test(key)) {
        return this.formatDateTime(val)
      }
      if (key === 'leaveDayCount') {
        const s = String(val).trim()
        if (!s) return '无'
        return /天$/.test(s) ? s : `${s}天`
      }
      if (typeof val === 'boolean') return val ? '是' : '否'
      if (typeof val === 'object') {
        if (Array.isArray(val)) {
          const parts = val.map(x => {
            if (x == null) return ''
            if (typeof x !== 'object') return String(x)
            return x.name || x.label || x.value || ''
          }).filter(Boolean)
          return parts.length ? parts.join('，') : '无'
        }
        return val.label || val.name || val.value || '无'
      }
      return String(val)
    },
    buildFormFields(data) {
      const source = data && typeof data === 'object' && !Array.isArray(data) ? data : {}
      const preferredOrder = [
        'flowTitle', 'billNo', 'flowUrgent',
        'applyUser', 'applyDate', 'applyDept', 'applyPost',
        'leaveType', 'funeralRelationType', 'leaveReason',
        'leaveStartTime', 'leaveEndTime', 'leaveDayCount', 'leaveHour'
      ]
      const keys = Object.keys(source).filter(k => !SKIP_KEYS.includes(k))
      const ordered = [
        ...preferredOrder.filter(k => keys.includes(k)),
        ...keys.filter(k => !preferredOrder.includes(k))
      ]
      return ordered
        .filter(key => source[key] !== undefined && source[key] !== null && source[key] !== '')
        .map(key => ({
          key,
          label: this.fieldLabelMap[key] || FIELD_LABELS[key] || key,
          value: this.formatFieldValue(key, source[key]),
          wide: WIDE_KEYS.includes(key)
        }))
    },
    parseFileList(data) {
      const raw = data && data.fileJson
      if (!raw) return []
      const parsed = this.safeParse(raw)
      return Array.isArray(parsed) ? parsed : []
    },
    normalizeRecords(list) {
      const rows = Array.isArray(list) ? list.slice() : []
      rows.sort((a, b) => {
        const ta = new Date(a && a.handleTime).getTime()
        const tb = new Date(b && b.handleTime).getTime()
        const na = Number.isNaN(ta) ? 0 : ta
        const nb = Number.isNaN(tb) ? 0 : tb
        return na - nb
      })
      return rows
    },
    async handleOpen() {
      if (!this.processId || !this.operatorId) {
        this.$message.warning('审批参数不完整')
        this.visibleProxy = false
        return
      }
      this.loading = true
      this.activeTab = 'form'
      this.formFields = []
      this.fileList = []
      this.formData = {}
      this.fieldLabelMap = {}
      this.records = []
      this.endTime = 0
      try {
        const res = await getFlowBeforeInfo(this.processId, { taskNodeId: this.taskNodeId })
        const data = res.data || {}
        const task = data.flowTaskInfo || {}
        this.flowTitle = task.fullName || this.payload.title || '流程审批'
        this.flowSubtitle = [
          task.flowName || this.payload.flowName || '无',
          task.thisStep ? `当前节点：${task.thisStep}` : ''
        ].filter(Boolean).join(' · ')
        this.enCode = this.payload.enCode || task.enCode || this.payload.flowCode || task.flowCode || ''
        this.formUrl = task.formUrl || ''
        this.formApiKey = this.resolveFormApiKey(task)
        this.records = this.normalizeRecords(data.flowTaskOperatorRecordList || [])
        this.endTime = Number(task.completion) === 100 ? (task.endTime || 0) : 0

        const templateMeta = this.safeParse(data.flowFormInfo)
        const metaList = this.isFormMetaList(templateMeta) ? templateMeta : []
        this.fieldLabelMap = this.buildLabelMapFromMeta(metaList, data.formOperates || [])

        const businessData = await this.loadBusinessFormData(task)
        this.formData = businessData && typeof businessData === 'object' ? businessData : {}
        this.fileList = this.parseFileList(this.formData)
        this.formFields = this.buildFormFields(this.formData)
      } catch (e) {
        this.$message.error('加载审批详情失败')
        this.visibleProxy = false
      } finally {
        this.loading = false
      }
    },
    openOpinionDialog(type) {
      this.opinionType = type
      this.opinion = ''
      this.opinionVisible = true
    },
    async submitApproval() {
      const payload = {
        handleOpinion: this.opinion || '',
        formData: this.formData,
        enCode: this.enCode
      }
      const isAudit = this.opinionType === 'audit'
      if (isAudit) this.auditing = true
      else this.rejecting = true
      try {
        const api = isAudit ? auditFlow : rejectFlow
        await api(this.operatorId, payload)
        this.$message.success(isAudit ? '审批已通过' : '已拒绝')
        this.opinionVisible = false
        this.$emit('success')
        this.visibleProxy = false
      } catch (e) {
        // 错误由拦截器处理
      } finally {
        this.auditing = false
        this.rejecting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .workflow-approval-dialog {
  max-width: 1100px;
  border-radius: 16px;
  padding: 0;
  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 0; }
}
.dialog-inner { display: flex; flex-direction: column; max-height: 90vh; }
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f1f5f9;
  background: rgba(224, 242, 254, 0.5);
}
.dialog-title { font-size: 17px; font-weight: 600; color: #0f172a; }
.dialog-subtitle { font-size: 12px; color: #64748b; margin-top: 2px; }
.dialog-close {
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #64748b;
  &:hover { background: rgba(0, 0, 0, 0.06); }
}
.dialog-body { flex: 1; min-height: 360px; overflow: auto; padding: 8px 20px 12px; }
.dialog-footer {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  padding: 12px 20px 16px;
  border-top: 1px solid #f1f5f9;
}
.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.bill-no { font-size: 13px; font-weight: 400; color: #909399; }
.mini-info-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 12px;
  background: #f7f8fa;
}
.mini-info-item { min-width: 0; }
.mini-label {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}
.mini-value {
  display: block;
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bill-kv-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  margin-bottom: 12px;
  background: #ebeef5;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}
.bill-kv {
  min-width: 0;
  padding: 12px 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.bill-kv--wide { grid-column: 1 / -1; }
.bill-k { font-size: 12px; color: #909399; }
.bill-v {
  font-size: 13px;
  color: #303133;
  word-break: break-all;
  white-space: pre-wrap;
}
.bill-v--em { color: #409EFF; font-weight: 600; }
.bill-attach {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fff;
}
.bill-files { display: flex; flex-wrap: wrap; gap: 8px; }
.bill-file {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: #ecf5ff;
  color: #409EFF;
  font-size: 12px;
}
.leave-bill,
.generic-bill {
  padding: 4px 0 8px;
}
.empty-tip {
  padding: 40px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
@media (max-width: 900px) {
  .mini-info-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>
